"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoizedBoolean = void 0;
class MemoizedBoolean {
    constructor(initialValue, onChangeCallback) {
        this._val = initialValue;
        this.onChangeCallback = onChangeCallback;
    }
    get val() {
        return this._val;
    }
    set val(b) {
        if (this._val === b)
            return;
        this._val = b;
        this.onChangeCallback();
    }
    setValQuietly(val) {
        this._val = val;
    }
}
exports.MemoizedBoolean = MemoizedBoolean;
